module.exports = __webpack_public_path__ + "components/flag/static/square/tw-b1db70a1fa7432afaaaeebfea3e8d763.svg";